<template>
  <div class="calling-container" :class="{ '-calling': calling }">
    <div class="stationcalling">
      <div  @click="$emit('clearCalling')" class="message">
        <UIIcon name="alert-triangle" />
        <div class="f8">{{ $t('Calling for help') }}</div>
      </div>
      <UIIcon @click="$emit('clearCalling')" class="close" name="x" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import UIIcon from '@/core/shared/components/ui/UIIcon';

@Component({
  components: {
    UIIcon,
  },
  props: {
    calling: {
      type: Boolean,
      required: true,
    },
  },
})
export default class StationCalling extends Vue {}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.calling-container {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: -0.5rem;
  bottom: 0;
  pointer-events: none;
  will-change: opacity, transform;
  transform: translateZ(0);

  & .stationcalling {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    border: 0.5rem solid var(--colorSBRedFlat);
    background-color: rgba(236, 78, 54, 0.3);
    /* background-color: color-mod(var(--colorSBRedFlat) alpha(30%)); */
    overflow: hidden;
    transform: scale(1.1);
    transition: transform 0.3s ease, opacity 0.3s ease;

    & .message {
      position: absolute;
      right: -0.5rem;
      top: 0;
      bottom: 0;
      width: 10rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: var(--spacingSm);
      background-color: var(--colorSBRedFlat);
      cursor: pointer;

      & svg {
        fill: var(--colorWhite);
        height: 3rem;
        width: 3rem;
        margin-bottom: var(--spacingXS);
      }

      & div {
        color: var(--colorWhite);
        margin: 0;
      }
    }

    & .close {
      position: absolute;
      top: 0;
      right: 0.5rem;
      height: 2.5rem;
      width: 2.5rem;
      fill: var(--colorWhite);
      cursor: pointer;
    }
  }

  &.-calling {
    pointer-events: auto;

    & .stationcalling {
      transition: transform 0.3s ease, opacity 0.1s ease;
      opacity: 1;
      transform: scale(1);

      & .message {
        animation: pulseDirection 0.5s infinite alternate ease;
      }
    }
  }
}

@keyframes pulseDirection {
  from {
    transform: translateX(0.5rem);
  }
  to {
    transform: translateX(-0.5rem);
  }
}
</style>
